import { combineReducers } from 'redux';
import { interactiveMapReducer } from './map/reducer';
import { TEMP_PROJECT } from './project/reducer';

export const interactiveReducer = combineReducers({
  MAP: interactiveMapReducer,
  PROJECT: TEMP_PROJECT,
});
